import {
    AccountingConfigurationDto,
    FulfilmentMaximumVehiclesPerDeliveryMethodDto,
    ShipmentReadyConfigurationDto,
    StatisticsConfigurationDto
} from "../../../../api/cms";
import {CmsStorageConfigurationForm} from "./CmsStorageConfigurationForm";
import {CmsFulfillmentConfigurationForm, CmsFulfillmentConfigurationFormHelp} from "./CmsFulfillmentConfigurationForm";
import {CmsStatisticsConfigurationForm, CmsStatisticsConfigurationFormHelp} from "./CmsStatisticsConfigurationForm";
import {CmsAccountingConfigurationForm, CmsAccountingConfigurationFormHelp} from "./CmsAccountingConfigurationForm";
import {CmsShippingOptionConfigurationForm} from "./CmsShippingOptionConfigurationForm";
import {ShippingConfigConstruct} from "../../../../api";
import {CmsShipmentReadyConfigurationForm} from "./CmsShipmentReadyConfigurationForm";

interface CmsConfigurationFormData {
    storageCabinets: string[]
    storageWarehouseId: string
    fulfilmentMaximumVehiclesPerDeliveryMethod: FulfilmentMaximumVehiclesPerDeliveryMethodDto
    statisticsConfiguration: StatisticsConfigurationDto
    accountingConfiguration: AccountingConfigurationDto
    shippingOptionConfiguration: ShippingConfigConstruct
    shipmentReadyConfiguration: ShipmentReadyConfigurationDto[]
}

interface CmsConfigurationFormHelp {
    storageCabinets?: string
    storageWarehouseId?: string,
    fulfilmentMaximumVehiclesPerDeliveryMethod: CmsFulfillmentConfigurationFormHelp
    statisticsConfigurationDto: CmsStatisticsConfigurationFormHelp
    accountingConfiguration: CmsAccountingConfigurationFormHelp
}

interface SelectOption {
    value: string;
    label: string;
}

interface CmsConfigurationFormProps {
    value: CmsConfigurationFormData
    storageWarehouseOption: SelectOption[]
    onChange: (value: CmsConfigurationFormData) => any
    validate: () => Promise<any>
    validationFor: (key: string) => string | undefined
    saving: boolean
    loading: boolean
    help: CmsConfigurationFormHelp
    shippingClientOptions: { label: string, value: string }[]
}

const CmsConfigurationForm = function CmsConfigurationForm({
                                                               storageWarehouseOption,
                                                               value,
                                                               saving,
                                                               onChange,
                                                               validate,
                                                               loading,
                                                               validationFor,
                                                               shippingClientOptions,
                                                               help
                                                           }: CmsConfigurationFormProps) {
    return <div style={{flex: '1', overflow: 'auto', padding: '1em'}}>
        <CmsAccountingConfigurationForm
            value={{accountingConfiguration: value.accountingConfiguration}}
            onChange={v => {
                onChange({
                    ...value,
                    accountingConfiguration: v.accountingConfiguration
                })
            }}
            validate={validate}
            saving={saving}
            help={help.accountingConfiguration}
        />
        <CmsStorageConfigurationForm
            value={{
                storageWarehouseId: value.storageWarehouseId,
                storageCabinets: value.storageCabinets
            }}
            storageWarehouseOption={storageWarehouseOption}
            onChange={v => {
                onChange({
                    ...value,
                    storageWarehouseId: v.storageWarehouseId,
                    storageCabinets: v.storageCabinets
                })
            }}
            validate={validate}
            saving={saving}
            help={{
                storageWarehouseId: help.storageWarehouseId,
                storageCabinets: help.storageCabinets
            }}
        />
        <CmsFulfillmentConfigurationForm
            value={{fulfilmentMaximumVehiclesPerDeliveryMethod: value.fulfilmentMaximumVehiclesPerDeliveryMethod}}
            onChange={v => {
                onChange({
                    ...value,
                    fulfilmentMaximumVehiclesPerDeliveryMethod: v.fulfilmentMaximumVehiclesPerDeliveryMethod
                })
            }}
            validate={validate}
            saving={saving}
            help={help.fulfilmentMaximumVehiclesPerDeliveryMethod}
        />
        <CmsStatisticsConfigurationForm
            value={{statisticsConfiguration: value.statisticsConfiguration}}
            onChange={v => {
                onChange({
                    ...value,
                    statisticsConfiguration: v.statisticsConfiguration
                })
            }}
            validate={validate}
            saving={saving}
            help={help.statisticsConfigurationDto}/>
        <CmsShipmentReadyConfigurationForm
            validate={validate}
            value={value.shipmentReadyConfiguration}
            onChange={v => {
                onChange({
                    ...value,
                    shipmentReadyConfiguration: v
                })
            }}
            saving={saving}
        />
        <CmsShippingOptionConfigurationForm
            value={value.shippingOptionConfiguration}
            onChange={v => {
                onChange({
                    ...value,
                    shippingOptionConfiguration: v
                })
            }}
            validate={validate}
            validationFor={validationFor}
            saving={saving}
            loading={loading}
            selectClientOptions={shippingClientOptions}
        />
    </div>
}

export {
    CmsConfigurationForm
}
